import { Drawer } from "@mui/material"
import React, { useCallback, useState } from "react"
import DrawerHeader from "./DrawerHeader"
import DrawerContent from "./DrawerContent"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { useNavigate } from "react-router-dom"
import { fetchClickedNotification, fetchUpdatedNotification } from "../../../redux/notifications/notificationsSlice"
import { setIsFiltered } from "../../../redux/global/globalSlice"
import { NotificationType } from "../../../redux/notifications/notificationsTypes"
import { getLast3Months } from "../../../helpers/months"
import { formateDateToString } from "../utils/formateDateToString"
import { setActiveFsFilters } from "../../../redux/filters/filtersSlice"
import { flattenData } from "../filters/selects/FilterComponent"
import { PagesName } from "../navigation/types/pages"

const getPageNameForNotificationNavigation = (pageFocus: NotificationType) => {
    switch (pageFocus) {
        case NotificationType.CLIENTS:
            return PagesName.CLIENTS
        case NotificationType.PRODUCTS:
            return PagesName.PRODUCTS
        case NotificationType.WAREHOUSES:
            return PagesName.WAREHOUSES
    }
}


export const NotificationsDrawer = ({ open, setOpen }: { open: boolean, setOpen: React.Dispatch<React.SetStateAction<Boolean>> }) => {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [tabValue, setValue] = useState(0)
    const { fsFilters } = useAppSelector((state) => state.filters)
    const { notifications } = useAppSelector((state) => state.notifications)

    const notificationsArchived =
        notifications &&
        notifications.filter((el) => el.isArchived === true)

    const notificationsNotArchived =
        notifications &&
        notifications.filter((el) => el.isArchived === false)

    const handleChange = () => {
        setValue((value) => (value === 0 ? 1 : 0))
    }

    const _archiveNotification = useCallback(
        (notificationId: string, notificationUpdate: Partial<Notification>) => {
            dispatch(
                fetchUpdatedNotification(notificationId, notificationUpdate)
            )
        },
        [dispatch]
    )
    const _clickNotification = useCallback(
        (notificationId: string) => {
            dispatch(fetchClickedNotification(notificationId)
            )
        },
        [dispatch]
    )

    const handleArchive = (
        notificationId: string,
        notificationUpdate: Partial<Notification>
    ) => {
        _archiveNotification(notificationId, notificationUpdate)
    }

    const _setIsFilteredFS = useCallback(
        (isFiltered: boolean) => dispatch(setIsFiltered(isFiltered)),
        [dispatch]
    )

    const handleClickNotificationButton = async (
        dataId: string,
        type: NotificationType,
        pageFocus: NotificationType,
        distrib: string,
        notificationId: string,
    ) => {
        setOpen(false)
        const pageToNavigate = getPageNameForNotificationNavigation(pageFocus)
        const last3Months = getLast3Months(new Date(fsFilters.min), new Date(fsFilters.max))
        const formatedDate = formateDateToString(last3Months.start, last3Months.end)
        _setIsFilteredFS(true) // Set isFiltered to true and make work handleClearFilters function
        _clickNotification(dataId)
        switch (type) {
            case NotificationType.PRODUCTS:
                dispatch(setActiveFsFilters({
                    startDate: formatedDate.start,
                    endDate: formatedDate.end,
                    min: fsFilters.min,
                    max: fsFilters.max,
                    clients: [],
                    universes: [],
                    suppliers: [],
                    regions: [],
                    categories: [],
                    products: fsFilters ? [flattenData(fsFilters.products.data).filter((el) =>
                        el.id.split("_").includes(dataId)
                    )[0].id] : []
                }))
                return navigate(`/food-service/${distrib}/${pageToNavigate}?notification=${notificationId}`)

            case NotificationType.CLIENTS:
                dispatch(setActiveFsFilters({
                    startDate: formatedDate.start,
                    endDate: formatedDate.end,
                    min: fsFilters.min,
                    max: fsFilters.max,
                    clients: fsFilters ? [flattenData(fsFilters.clients.data).filter((el) =>
                        el.id.includes(dataId)
                    )[0].id] : [],
                    universes: [],
                    suppliers: [],
                    regions: [],
                    categories: [],
                    products: []
                }))
                return navigate(`/food-service/${distrib}/${pageToNavigate}?notification=${notificationId}`)
            case NotificationType.WAREHOUSES:
                dispatch(setActiveFsFilters({
                    startDate: formatedDate.start,
                    endDate: formatedDate.end,
                    min: fsFilters.min,
                    max: fsFilters.max,
                    clients: [],
                    universes: [],
                    suppliers: [],
                    regions: fsFilters ? [flattenData(fsFilters.regions.data).filter((el) =>
                        el.id.split("_").includes(dataId)
                    )[0].id] : [],
                    categories: [],
                    products: []
                }))
                return navigate(`/food-service/${distrib}/${pageToNavigate}?notification=${notificationId}`)
        }
    }


    return (

        <Drawer
            anchor="right"
            PaperProps={{ sx: { width: '35vw' } }
            }
            open={open}
            onClose={() => setOpen(false)}
        >
            <DrawerHeader
                tabValue={tabValue}
                notificationsArchived={notificationsArchived}
                notificationsNotArchived={notificationsNotArchived}
                handleChange={handleChange}
                setOpen={setOpen}
            />
            <DrawerContent
                tabValue={tabValue}
                notificationsArchived={notificationsArchived}
                notificationsNotArchived={notificationsNotArchived}
                handleArchive={handleArchive}
                handleChange={handleChange}
                handleClickNotificationButton={handleClickNotificationButton}
            />
        </Drawer>)
}